import URL from '@/tools/url';
import jquery from 'jquery';

/**
 * @memberof module:ajaxAPI/cart
 * @alias get
 *
 * @description Получение состава корзины
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.cart.get()
 *  .done(function (onDone) { console.log('onDone:', onDone) })
 *  .fail(function (onFail) { console.log('onFail:', onFail) });
 */

export default function() {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = { lang: _lang };

  /*
   * В куке состав корзины хранится, если там не более 4х РАЗНЫХ модификаций
   * Кука может быть пустой - дергаем инфу с сервера
   * Если кука содержит строку 'json' - дергаю инфу с сервера
   */

  return jquery.getJSON('/cart_items/v2.json', fields);
};
